export default [
    {
        date: 1584373013613,
        row: 6,
        col: 6,
        segments: [
            [2, 6, 2, 3],
            [2, 3, 3, 2],
            [3, 2, 4, 2],
            [4, 2, 5, 3],
            [5, 3, 5, 6],
            [5, 6, 2, 6],
            [3, 6, 3, 5],
            [3, 5, 4, 5],
            [4, 5, 4, 6],
            [3, 3, 4, 3],
            [4, 3, 4, 4],
            [4, 4, 3, 4],
            [3, 4, 3, 3],
        ],
    },
];
